import { render, staticRenderFns } from "./lcfw.vue?vue&type=template&id=4c07d846&scoped=true&"
import script from "./lcfw.vue?vue&type=script&lang=js&"
export * from "./lcfw.vue?vue&type=script&lang=js&"
import style0 from "./lcfw.vue?vue&type=style&index=0&id=4c07d846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c07d846",
  null
  
)

export default component.exports